import Command from './Command';
import common from '../common';

export default class JumpCommand extends Command {
	constructor() {
		super('ui_function_jump_bg_9slice');

		this.type = Command.TYPE_JUMP;

		this.options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		this.signals.onVariableTouch = new P3.utils.MiniSignal();

		this.init();
	}

	init() {
		super.init('GAME.BLOCKS.JUMP', 'ui_icon_jump');

		this.player.signals.jumped.add(() => {
			this.signals.executionComplete.dispatch();
		}, this);

		this.on('pointertap', (e) => {
			if (!this.canChangeVariable) {
				return;
			}
			this.signals.onVariableTouch.dispatch(this, e);
		});

		this.variableBackground.visible = this.variableActive;
		this.variableLabel.visible = this.variableActive;
	}

	setText(text) {
		if (!this.variableActive) {
			text = '';
		}

		this.variableLabel.text = `${text}`;
	}

	onPointerMove(event) {
		super.onPointerMove(event);

		/* if (this.grabbing) {
			if (this.y - this.height * 0.5 < 0) {
				this.y = this.height * 0.5;
			} else if (this.y + this.height * 0.5 > common.STAGE_HEIGHT) {
				this.y = common.STAGE_HEIGHT - this.height * 0.5;
			}
		} */
	}

	execute() {
		if (!this.player.aliendata.canJump) {
			this.signals.executionComplete.dispatch();

			return;
		}

		this.player.jump(this.player.direction, 2, 4, 400);
	}
}
